import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { Product } from './Product'
import { Order } from './Order'
import { Sku } from './Sku'

export class OrderUnit extends Base {
  @Expose({ name: 'sku' })
  @Transform(({ sku }) => sku?.guid)
  guid: string = ''

  @Type(() => Order)
  order?: Order

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Expose({ name: 'num_units' })
  numUnits?: string

  @Expose({ name: 'num_picked' })
  numPicked?: string

  @Expose({ name: 'num_fulfilled' })
  numFulfilled?: string

  status?: string
}
